import React from 'react';

import thumbnailPic from '../../../../static/images/images_placeholder.svg';
import useImageFallback from '../../../hooks/useImageFallback';
import useMediaProcessingStatus from '../../../hooks/useMediaProcessingStatus';
import MediaProcessingStatus from './MediaProcessingStatus';
import RotatedImagePreview from './RotatedImagePreview';

import * as styles from '../UploadAssetWidget.scss';

const ImageWrapper = properties => {
  const { src: displayedImage, onError } = useImageFallback(properties?.image, { placeholder: thumbnailPic });

  const { isPending, isSlow, hasError } = useMediaProcessingStatus({
    mediaId: properties.mediaId,
    isPending: properties.isPending,
    hasError: properties.hasError,
    fetchStatus: properties.fetchStatus,
    onSettled: properties.onMediaStatusChange
  });

  const showPlaceholder = isPending || hasError;
  const labelKey = showPlaceholder ? properties.getLabelKey?.({ hasError, isSlow, compact: properties.compact }) : null;

  return (
  <div className={styles.imageWrapper}>
    {showPlaceholder ? (
      <MediaProcessingStatus isFailed={hasError} labelKey={labelKey} compact={properties.compact} />
    ) : (
      <RotatedImagePreview
        id={properties.id}
        angle={properties.angle}
        isRaw={properties.isRaw}
        image={displayedImage}
        onImageError={properties.isRaw ? undefined : onError}
      />
    )}

    { (properties.uploadInProgress) && (
      <div className={styles.uploadProgress}>
        <div id={`uploadProgressBar_${properties.id}`} />
      </div>
    ) }

    {(properties.isVideo && !showPlaceholder) && <i className="icon icon-widget-video" />}
  </div>
  );
};

export default ImageWrapper;
